import { render, staticRenderFns } from "./TabSome.vue?vue&type=template&id=500561a0&"
import script from "./TabSome.vue?vue&type=script&lang=js&"
export * from "./TabSome.vue?vue&type=script&lang=js&"
import style0 from "./TabSome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports